import React from 'react';
import { Navigate, useNavigate, Link } from 'react-router-dom'
import { useSystemOptionsStore } from '../stores/useOptions';
import ResultadosVotacion from './ResultadosVotacion';

const SeccionPresupuestoHome = () => {
  const { systemOptions } = useSystemOptionsStore();
  const navigate = useNavigate();
  const navigateToPropuestas = (destino) => {
    const destinourl = '/propuestas/';
    navigate(destinourl);
  }

  const estilos = {
    cardHeader: {
      backgroundColor: '#0A4A2F',
      color: 'white',
      borderRadius: '0.5rem 0.5rem 0 0'
    },
    card: {
      borderRadius: '0.5rem',
      border: 'none',
      transition: 'transform 0.2s ease',
      height: '100%'
    },
    cardHover: {
      transform: 'translateY(-3px)',
      boxShadow: '0 4px 8px rgba(0,0,0,0.1)'
    },
    borderPink: {
      borderTop: '3px solid #E6007E'
    }
  };

  return (
    <section className="py-5 bg-light">



      <div className="container">

      <ResultadosVotacion/>

        <h1 className="text-center mb-5" style={{ color: '#0A4A2F' }}>
          Propuestas del Presupuesto Participativo
        </h1>

        <div className="row g-4 mb-5">
          {/* Card Información General */}
          <div className="col-lg-8">
            <div className="card shadow-sm h-100" style={estilos.card}>
              <div className="card-header" style={estilos.cardHeader}>
                <h2 className="h4 mb-0">Información General</h2>
              </div>
              <div className="card-body">
                <p className="mb-4">
                  Acá vas a encontrar todas las propuestas que cumplieron con los requisitos
                  de la Ordenanza Nº 5306/2022 y el apto técnico y presupuestario para poder
                  formar parte y que puedan ser analizados y elegidos por la comunidad.
                </p>
                <button type="button" disabled onClick={navigateToPropuestas} className="btn btn-outline-light btn-lg px-4 me-md-2 fw-bold" style={{ color: '#E91E63', border: '1px solid #ccc' }}>Ver todas las propuestas</button>
                <p className="mb-0 mt-4">
                  Cada uno de los proyectos fue evaluado por el Foro del Presupuesto Participativo.
                </p>
              </div>
            </div>
          </div>



          {/* Card Proyectos Ganadores */}
          <div className="col-lg-4">
            <div className="card shadow-sm h-100" style={estilos.card}>
              <div className="card-header" style={estilos.cardHeader}>
                <h2 className="h4 mb-0">Proyectos Ganadores</h2>
              </div>
              <p className='pt-4 px-4'>
                La ejecución de las propuestas ganadoras se hará con fondos propios de la Municipalidad; y resultarán ganadores
              </p>
              <div className="card-body">
                <ul className="list-unstyled mb-0 mt-0">
                  {[
                    '3 proyectos de Trenque Lauquen',
                    '1 proyecto de 30 de Agosto',
                    '1 proyecto de Beruti',
                    '1 proyectos del Presupuesto Participativo Joven'
                  ].map((item, index) => (
                    <li key={index} className="mb-2 d-flex">
                      <span className="me-2" style={{ color: '#0A4A2F' }}>✓</span>
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="row g-4 mb-5">
          {/* Card Información General */}
          <div className="col-lg-8">
            <div className="card shadow-sm h-100" style={estilos.card}>
              <div className="card-header" style={estilos.cardHeader}>
                <h2 className="h4 mb-0">Información General</h2>
              </div>
              <div className="card-body">
                <p className="mb-4">
                  Acá vas a encontrar todas las propuestas que cumplieron con los requisitos
                  de la Ordenanza Nº 5306/2022 y el apto técnico y presupuestario para poder
                  formar parte y que puedan ser analizados y elegidos por la comunidad.
                </p>
                
                <p className="mb-0 mt-4">
                  Cada uno de los proyectos fue evaluado por el Foro del Presupuesto Participativo.
                </p>
              </div>
            </div>
          </div>





                

          </div>
       

        {/* Sección de Votación */}
        <h3 className="text-center mb-4" style={{ color: '#0A4A2F' }}>¿Cómo votar?</h3>
        <div className="row g-4">
          {/* Card Votación Online */}
          <div className="col-md-6">
            <div className="card shadow-sm h-100" style={{ ...estilos.card, ...estilos.borderPink }}>
              <div className="card-body">
                <h4 className="h5 mb-3" style={{ color: '#0A4A2F' }}>Votación Online</h4>
                <p className="mb-2">Desde el lunes 11 de noviembre a partir de las 7:00 de la mañana hasta el viernes 15 de noviembre de 2024 hasta las 13:00.</p>
                <p className="mb-0 text-muted">A través de esta plataforma</p>

              </div>
            </div>
          </div>

          {/* Card Votación Presencial */}
          <div className="col-md-6">
            <div className="card shadow-sm h-100" style={{ ...estilos.card, ...estilos.borderPink }}>
              <div className="card-body">
                <h4 className="h5 mb-3" style={{ color: '#0A4A2F' }}>Votación Presencial</h4>
                <p>También vas a poder votar de forma presencial en las mesas que estarán dispuestas en tres puntos del distrito: </p>
                <ul className="list-unstyled mb-0 mt-0 pt-0">
                  {[
                    'Hall central del Palacio Municipal - Trenque Lauquen',
                    'Oficinas del Ente Descentralizado - 30 de Agosto',
                    'Oficinas de la Delegación - Beruti'
                  ].map((lugar, index) => (
                    <li key={index} className="mb-2">
                      <span style={{ color: '#E6007E' }}>•</span> {lugar}
                    </li>
                  ))}
                </ul>
                <p className="mb-2">Del lunes 11 al viernes 15 de noviembre de 2024</p>
                <p className="mb-0 text-muted">Horario: 7:00 a 13:00</p>
              </div>
            </div>
          </div>
        </div>

        {/* Nota Final */}
        <p className="text-center text-muted mt-5 mb-0">
          Las propuestas que no resulten ganadoras quedarán en el Banco de Proyectos
          para ser evaluadas su ejecución en años sucesivos.
        </p>
      </div>
    </section>
  );
};

export default SeccionPresupuestoHome;